<template>
  <div class="upload">
    <el-button
      class="upload__btn"
      @click="onDefaultSelect"
    >Use ESU2 Logo</el-button>
  </div>
</template>

<script>
import 'cropperjs/dist/cropper.css'
import { mapState } from 'vuex'

export default {
  name: 'UseDefaultImage',

  props: {
    cropWidth: {
      type: Number,
      default: null
    },
    cropHeight: {
      type: Number,
      default: null
    },
    quality: {
      type: Number,
      default: 0.9
    }
  },

  data () {
    return {
      imageLink: ''
    }
  },

  computed: {
    ...mapState(['attributes', 'basic', 'attributes']),
    imageUrl: {
      get () {
        return this.basic.image.link
      },
      set (v) {
        this.$store.dispatch('updateImage', { link: v })
      }
    }
  },

  methods: {
    onDefaultSelect () {
      this.$store.dispatch('updateImage', { link: 'https://www.esu2.org/wp-content/uploads/2022/12/esu2logo.png' })
    }
  }
}
</script>

<style lang="scss">
@import '../assets/scss/variables.scss';

.crop-preview-wrapper {
   overflow: hidden;
   padding-bottom: 5px;
}
.crop-preview {
  padding: 2px 0;
  max-height: 250px;
  padding-bottom: 20px;
  img {
     max-width: 100%;
  }
  &__placeholder {
    width: 100%;
    height: 200px;
    background-color: #eee;
    border: 1px dashed $color-info;
    border-radius: 3px;
  }
}
.upload-action, .aspect-ratio-buttons {
  text-align: center;
}
.aspect-ratio-buttons {
  margin-bottom: 10px;
}
.upload {
  width: fit-content;
}
</style>
